/**
 * Aba e escala da Capacidade da Fábrica lembradas por unidade neste aparelho
 * (`tenantStorage`, varrido no logout como todo estado operacional).
 */
import { useCallback, useState } from "react";

import { ESCALA } from "../../utils/capacidade";
import { getItemTenant, setItemTenant } from "../../utils/tenantStorage";
import { ESCALAS, abasDaPagina } from "./apresentacao";

export const CHAVE_PREFERENCIAS = "pharuerp:capacidade-fabrica:prefs:v1";

const PADRAO = Object.freeze({ aba: "ocupacao", escala: ESCALA.MES });
// Todas as abas que existem; quem não tem permissão para uma delas volta
// para Ocupação na página (a preferência não sabe do perfil).
const ABAS_CONHECIDAS = abasDaPagina({ podeMarcarExcecao: true });

export function normalizarPreferencias(bruto) {
  return {
    aba: ABAS_CONHECIDAS.some((a) => a.id === bruto?.aba) ? bruto.aba : PADRAO.aba,
    escala: ESCALAS.some((e) => e.id === bruto?.escala) ? bruto.escala : PADRAO.escala,
  };
}

function ler() {
  try {
    return normalizarPreferencias(JSON.parse(getItemTenant(CHAVE_PREFERENCIAS) || "null"));
  } catch {
    // Valor corrompido ou storage bloqueado: começa do padrão.
    return { ...PADRAO };
  }
}

function gravar(preferencias) {
  try {
    setItemTenant(CHAVE_PREFERENCIAS, JSON.stringify(preferencias));
  } catch {
    // Storage cheio ou bloqueado (aba anônima): a preferência só não é lembrada.
  }
}

export default function usePreferencias() {
  const [preferencias, setPreferencias] = useState(ler);

  const alterar = useCallback((campo, valor) => {
    setPreferencias((atual) => {
      const proximo = normalizarPreferencias({ ...atual, [campo]: valor });
      gravar(proximo);
      return proximo;
    });
  }, []);

  const setAba = useCallback((aba) => alterar("aba", aba), [alterar]);
  const setEscala = useCallback((escala) => alterar("escala", escala), [alterar]);
  return { ...preferencias, setAba, setEscala };
}
